import { faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import T from 'i18n-react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as CommonStore from '../../store/Common';

class PaymentSummary extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <>
                <div className="payment-summary">
                    <span><FontAwesomeIcon size="1x" className="mr-3" icon={faMoneyBillWave} /></span>
                    <span>{T.translate('paymentSummary.amountToBeCharged')}</span>
                    <span className="amount">${this.props.amount}</span>
                </div>
            </>
        );
    }
}

export default connect(
    state => ({ ...state.common }),
    dispatch => bindActionCreators({ ...CommonStore.actionCreators }, dispatch)
)(PaymentSummary);